import { render, staticRenderFns } from "./Wordclouds.vue?vue&type=template&id=662ded27&"
import script from "./Wordclouds.vue?vue&type=script&lang=ts&"
export * from "./Wordclouds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports